import React, { useState } from 'react';
import { db } from '../../../firebase';
import { ref, push } from 'firebase/database';
import { FiCheckCircle, FiBook, FiAward, FiClock, FiUser, FiLayers } from 'react-icons/fi';

const ADCA = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await push(ref(db, 'enquiries/adca'), {
        ...form,
        course: 'ADCA',
        createdAt: new Date().toISOString()
      });
      setSubmitted(true);
      setForm({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      alert('Error saving data!');
    } finally {
      setIsLoading(false);
    }
  };

  const features = [
    { icon: <FiAward className="feature-icon" />, text: 'Advanced Diploma Certification' },
    { icon: <FiLayers className="feature-icon" />, text: 'Comprehensive computer applications training' },
    { icon: <FiUser className="feature-icon" />, text: 'Eligibility: 10th pass or equivalent' },
    { icon: <FiClock className="feature-icon" />, text: 'Duration: 1 year' },
    { icon: <FiBook className="feature-icon" />, text: 'Practical training with industry projects' }
  ];

  return (
    <div className="adca-container">
      <div className="adca-card">
        <div className="adca-header">
          <span className="adca-badge">Best Seller</span>
          <h2 className="adca-title">ADCA Course</h2>
          <p className="adca-subtitle">Advanced Diploma in Computer Applications</p>
          
          <div className="adca-highlights">
            <span className="highlight-item">
              <FiClock className="highlight-icon" /> 1 Year
            </span>
            <span className="highlight-item">
              <FiUser className="highlight-icon" /> 10th Pass
            </span>
          </div>
        </div>

        <div className="adca-image-container">
          <img 
            src="https://images.unsplash.com/photo-1551033406-611cf9a28f67?auto=format&fit=crop&w=600&q=80" 
            alt="ADCA Course" 
            className="adca-image" 
          />
        </div>

        <div className="adca-features">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              {feature.icon}
              <span>{feature.text}</span>
            </div>
          ))}
        </div>

        <form onSubmit={handleSubmit} className="adca-form">
          <div className="form-group">
            <input 
              type="text" 
              name="name" 
              placeholder="Your Full Name" 
              required 
              value={form.name} 
              onChange={handleChange} 
              className="form-input" 
            />
          </div>
          
          <div className="form-group">
            <input 
              type="email" 
              name="email" 
              placeholder="Your Email Address" 
              required 
              value={form.email} 
              onChange={handleChange} 
              className="form-input" 
            />
          </div>
          
          <div className="form-group">
            <input 
              type="tel" 
              name="phone" 
              placeholder="Your Phone Number" 
              required 
              value={form.phone} 
              onChange={handleChange} 
              className="form-input" 
            />
          </div>
          
          <div className="form-group">
            <textarea 
              name="message" 
              placeholder="Your Message or Questions" 
              required 
              value={form.message} 
              onChange={handleChange} 
              className="form-textarea" 
            />
          </div>
          
          <button 
            type="submit" 
            className={`submit-button ${submitted ? 'success' : ''} ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? (
              'Processing...'
            ) : submitted ? (
              <>
                <FiCheckCircle className="button-icon" />
                Enquiry Submitted!
              </>
            ) : (
              'Apply Now'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ADCA;

// CSS Styles
const styles = `
  .adca-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  }

  .adca-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 2.5rem;
    max-width: 480px;
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  .adca-header {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .adca-badge {
    display: inline-block;
    background-color: #ff6b6b;
    color: white;
    padding: 0.3rem 0.8rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .adca-title {
    color: #2b2d42;
    font-weight: 700;
    margin-bottom: 0.5rem;
    font-size: 1.8rem;
  }

  .adca-subtitle {
    color: #4a4e69;
    margin-bottom: 1rem;
    font-size: 1rem;
    line-height: 1.5;
  }

  .adca-highlights {
    display: flex;
    justify-content: center;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .highlight-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    font-weight: 500;
    color: #4a4e69;
  }

  .highlight-icon {
    color: #6C4DF6;
  }

  .adca-image-container {
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 1.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .adca-image {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.3s ease;
  }

  .adca-image:hover {
    transform: scale(1.02);
  }

  .adca-features {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-bottom: 1.5rem;
  }

  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 0.8rem;
    color: #4a4e69;
    font-size: 0.95rem;
    line-height: 1.4;
  }

  .feature-icon {
    color: #6C4DF6;
    margin-top: 0.2rem;
    flex-shrink: 0;
  }

  .adca-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .form-input, .form-textarea {
    padding: 0.8rem 1rem;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    font-size: 0.95rem;
    transition: all 0.2s;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
  }

  .form-input:focus, .form-textarea:focus {
    border-color: #6C4DF6;
    box-shadow: 0 0 0 3px rgba(108, 77, 246, 0.1);
  }

  .form-textarea {
    min-height: 100px;
    resize: vertical;
  }

  .submit-button {
    padding: 0.9rem;
    border-radius: 8px;
    background: linear-gradient(90deg, #6C4DF6, #8B5CF6);
    color: #fff;
    font-weight: 600;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.5rem;
    box-shadow: 0 4px 6px rgba(108, 77, 246, 0.2);
  }

  .submit-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(108, 77, 246, 0.25);
  }

  .submit-button:active {
    transform: translateY(0);
  }

  .submit-button.success {
    background: #48BB78;
    box-shadow: 0 4px 6px rgba(72, 187, 120, 0.2);
  }

  .submit-button.loading {
    background: #a78bfa;
    cursor: not-allowed;
  }

  .button-icon {
    margin-right: 8px;
  }
`;

// Add styles to the document head
const styleElement = document.createElement('style');
styleElement.innerHTML = styles;
document.head.appendChild(styleElement);